import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ISubscription } from 'models/subscriptions.model'
import { CURRENCY_SYMBOLS } from 'modules/purchase/constants'
import checkIcon from 'assets/images/sprite/check-icon.svg'
import { SvgImage } from 'components/SvgImage'
import { StyledSubscriptionItemV2 as S } from './SubscriptionItemV2.styles'

type TProps = {
  subscription: ISubscription
  isSelected: boolean
}

export const SubscriptionItemV2: React.FC<TProps> = ({
  subscription: {
    periodQuantity,
    oldPriceSecond,
    priceId,
    isDefault,
    customPrice,
    currency,
  },
  isSelected,
}) => {
  const { t } = useTranslation()

  const oldPriceSecondWithFractionalPart = useMemo(
    () => oldPriceSecond.toFixed(2),
    [oldPriceSecond],
  )

  const [integerPrice, decimalPrice] = useMemo(
    () => String(customPrice).split('.'),
    [customPrice],
  )

  return (
    <>
      {isDefault && (
        <S.MostPopularBadge>{t`purchase.subscription.mostPopularBadge`}</S.MostPopularBadge>
      )}
      <S.Wrapper key={priceId} isSelected={isSelected} isDefault={isDefault}>
        <S.Content>
          <S.SelectionOption isSelected={isSelected}>
            <SvgImage svg={checkIcon} width={30} />
          </S.SelectionOption>
          <S.PlanContainer>
            <S.PlanPeriod isSelected={isSelected}>
              {t('purchase.subscription.monthlyPeriod', {
                periodQuantity,
              })}
            </S.PlanPeriod>
          </S.PlanContainer>
        </S.Content>

        <S.Content>
          <S.PreviousPriceCrossed>
            {CURRENCY_SYMBOLS[currency]}
            {oldPriceSecondWithFractionalPart}
          </S.PreviousPriceCrossed>
          <S.CustomPrice isSelected={isSelected}>
            <S.Currency>{CURRENCY_SYMBOLS[currency]}</S.Currency>
            <S.PriceValue>{integerPrice}</S.PriceValue>
            <S.DecimalPrice>
              <span>{decimalPrice}</span>
              <S.Period>
                {t`purchase.subscription.interval`}{' '}
                {t('purchase.subscription.week')}
              </S.Period>
            </S.DecimalPrice>
          </S.CustomPrice>
        </S.Content>
      </S.Wrapper>
    </>
  )
}
